module.exports = __webpack_public_path__ + "static/media/rasamrice.a60162b5.jpg";